// Single job: wrap App in the root ErrorBoundary (full-screen Reload, never a blank app) and own the
// Reload side effect. Separate from index.js so the wiring is testable without Sentry.init/createRoot.
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { AppCrashScreen } from "./components/ui/CrashFallback";
import { reloadApp, getOrigin, getPathname } from "./lib/platform";

const reloadToHome = () => reloadApp(getOrigin() + getPathname() + '?_v=' + Date.now());
const rootFallback = () => <AppCrashScreen onReload={reloadToHome} />;

export default function AppRoot() {
  return (
    <ErrorBoundary name="root" fallback={rootFallback}>
      <App />
    </ErrorBoundary>
  );
}
